<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="EC_width content">
      <div class="leftContent">
        <div class="title"
             v-html="articlelist.title"></div>
        <div class="titleSub"
             v-html="articlelist.communicationAuthor">
          <!-- {{ apiData.personnel }} -->
        </div>
        <div class="introGray">
          <p v-html="articlelist.communicationAuthorAddress"></p>
          <p><span class="fontBold font_normal_color">key Word：</span>{{ articlelist.keywords}}</p>
          <p><span class="fontBold font_normal_color">Doi：</span>{{ articlelist.doi }}</p>
        </div>
        <div class="titleStlye marginTop20 marginBottom30">
          <span>Cite this artical</span>
        </div>
        <div class="titleSub"
             v-html="articlelist.indexContent"></div>
        <div class="introGray">
          <div class="pdfWrap marginTop20">
            <a href="javascript:;"
               @click="pdfload(articlelist)">
              <span><img src="/image/english/dpdf.png" /></span>
              <span>DOWNLOAD THE PDF</span>
            </a>
          </div>
        </div>
        <div class="titleStlye marginTop30 marginBottom10">
          <span>ABSTRACT</span>
        </div>
        <div class="infor">
          <p v-html="articlelist.abstract"></p>
        </div>
        <div class="titleStlye marginTop30 marginBottom10"
             v-if="articlelist.reference != ''">
          <span>REFRENCE</span>
        </div>
        <div class="infor scrollWrap"
             style="border: none;"
             v-if="articlelist.reference != ''">
          <p v-html="articlelist.reference"></p>
        </div>
        <div class="grayBar marginTop30"><span class="fontBold">project find:</span>chinese national interval</div>
        <div class="pagationWrap">
          <div class="marginTop30 tipsHover"
               v-if="lastlist.id > 0">
            <div class="page_btn marginRight10">
              &lt;
            </div>
            <a href="javascript:;"
               @click="lastnextclk(lastlist)"
               class="page_btn_active_link"><span class="fontBold">Previous：</span>{{ lastlist.title }}</a>
          </div>
          <div class="marginTop20 tipsHover"
               v-if="nextlist.id > 0">
            <div class="page_btn  marginRight10">
              &gt;
            </div>
            <a href="javascript:;"
               @click="lastnextclk(nextlist)"
               class="page_btn_active_link"><span class="fontBold">Next：</span>{{ nextlist.title }}</a>
          </div>
        </div>
      </div>
      <div class="rightVideoList">
        <div class="rightVedioTitle display_between">
          <div class="leftTitle">Relatad Video</div>
          <div>
            <a href="javascript:;"><img src="/image/index/moreimg.png"
                   class="marginRight5" />More</a>
          </div>
        </div>
        <div class="videoWrap marginBottom30"
             v-for="(item, index) in recommendCourseList"
             :key="index + 'GG'"
             @click="courseclick(item)">
          <!-- <video src="" controls="controls">当前浏览器不支持 video直接播放，点击这里下载视频： <a href="myvideo.webm">下载视频</a></video> -->
          <img :src="item.acr_PictResUrl"
               width="300"
               height="169" />
          <div class="videoTitle ">
            {{ item.title }}
          </div>
        </div>
        <div class="rightVedioTitle display_between">
          <div class="leftTitle">Relatad Articles</div>
        </div>
        <div class="videoArtItem"
             v-for="(item, index) in recommendArticleList"
             :key="index + 'SS'"
             @click="lastnextclk(item)"
             v-show="item.title">
          <a href="javascript:;">
            {{ item.title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage';
export default {
  name: 'enLiteDetail',
  components: {
    breadcrumbPage
  },
  data () {
    return {
      apiData: {},
      IsEnginfoShow: false,
      articlelist: {},
      lastlist: {},
      nextlist: {},
      year: '',
      period: '',
      recommendArticleList: [],
      recommendCourseList: []
    };
  },
  created () {
    this.getData();
    this.year = this.$route.query.nian;
    this.period = this.$route.query.qi;
    this.GetArticleInfoPageList(this.$route.query.id);
  },
  methods: {
    getData () {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          that.apiData = data.enLiteDetail;
        })
    },
    lastnextclk (item) {
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      } else {
        document.documentElement.scrollTop = 0;
      }
      this.year = item.nian;
      this.period = item.qi;
      this.GetArticleInfoPageList(item.id);
    },
    //根据id获取文献详情数据
    GetArticleInfoPageList (ID) {
      let _this = this;
      _this.lastlist = [];
      _this.nextlist = [];
      this.httphelper
        .post('/api/FmchApi/GetFmchArticleInfoPageList', {
          year: _this.year.toString(),
          period: _this.period.toString(),
          id: Number(ID),
          keywords: ''
        })
        .then(res => {
          if (res.data.code == 200) {
            //年卷树结构数据
            if (res.data.data.gpSiteFmchArticleInfoViews.length > 0) {
              _this.articlelist = res.data.data.gpSiteFmchArticleInfoViews[0];
            }
            _this.lastlist = res.data.data.lastNextPieceFmchViews[0];
            _this.nextlist = res.data.data.lastNextPieceFmchViews[1];

            //去掉html标签
            let keywork = _this.articlelist.keywords.replace(/<[^>]+>/g, '');
            let reg1 = new RegExp('；', 'g'); //g代表全部
            keywork = keywork.replace(reg1, ',');
            let reg2 = new RegExp(';', 'g'); //g代表全部
            keywork = keywork.replace(reg2, ',');
            _this.GetArticleRecommendPageList(keywork.replace(';', ',').replace('；', ','));
            _this.GetCourseRecommendPageList(keywork.replace(';', ',').replace('；', ','));
          }
        });
    },
    escapeHTML (untrusted) {
      // Escape untrusted input so that it can safely be used in a HTML response
      // in HTML and in HTML attributes.
      return untrusted
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }, //相关推荐
    GetArticleRecommendPageList (keywords) {
      let _this = this;
      _this.articleList = [];
      _this.httphelper
        .post('/api/ArticleApi/GetEnArticleRecommendPageList', {
          year: '',
          period: '',
          id: 0,
          keywords: keywords,
          recommendNumber: 5
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.recommendArticleList = res.data.data;
          }
        });
    },
    /**相关课程推荐 */
    GetCourseRecommendPageList (keywords) {
      let _this = this;
      _this.recommendCourseList = [];
      _this.httphelper
        .post('/api/ArticleApi/GetCourseRecommendPageList', {
          year: '',
          period: '',
          id: 0,
          keywords: keywords,
          recommendNumber: 5
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.recommendCourseList = res.data.data;
          }
        });
    },
    /**pdf下载 */
    pdfload (item) {
      window.location.href = item.pdF_LinkAddress
    },
    /** 更新PDF下载次数 */
    uppdfload (id) {
      let _this = this;
      _this.articleList = [];
      _this.httphelper.post('/api/ArticleApi/UpdPdfClickCount', {
        id: id
      });
    },
    /** 课程跳转*/
    courseclick (item) {
      let id = item.courseInfoId == 0 ? item.id : item.courseInfoId;
      let url = this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id;
      window.open(url);
    }
  }
};
</script>

<style scoped>
.content {
    padding-top: 30px;
    flex: 1;
    padding-bottom: 50px;
    display: flex;
}
.leftContent {
    flex: 1;
}
.title {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 30px;
}
.titleSub {
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
}
.introGray {
    color: #ccc;
    font-size: 16px;
    margin-top: 12px;
    border-bottom: 1px solid #333;
    padding-bottom: 18px;
}
.infor {
    font-size: 16px;
    border-bottom: 1px solid #333;
    padding-bottom: 40px;
}
.infor p {
    line-height: 2em;
}
.introGray p {
    margin-bottom: 14px;
}
.titleStlye {
    /* 	height: 60px;
            line-height: 60px; */
    font-size: 24px;
    font-weight: bold;
}
.titleStlye span {
    padding: 0 20px;
    border-left: 4px solid #0b8686;
}
.pdfWrap {
    height: 80px;
    line-height: 80px;
}
.pdfWrap a {
    font-size: 16px;
    color: #0b8686;
    font-weight: bold;
}
.scrollWrap {
    height: 500px;
    overflow: auto;
}
.grayBar {
    padding: 20px 25px;
    background: #f7f7f7;
    font-size: 18px;
}
.page_btn {
    color: #999;
    cursor: pointer;
    display: inline-block;
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    border-radius: 22px;
    border: 1px solid #ccc;
    background: #e5e5e5;
}
/* .page_btn_active {
    background: #0B8686;
    color: #fff;
    border: 1px solid #0B8686;
}
.page_btn_active_link {
    color: #0B8686;
}  */

/* 右侧样式设置 */
.rightVideoList {
    width: 310px;
}
/* 右面视频列表样式 */
.rightVideoList {
    margin-left: 50px;
}
.rightVedioTitle {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
}
.leftTitle {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #333;
}
.videoWrap video {
    width: 100%;
}
.videoTitle {
    font-size: 16px;
    margin-top: 12px;
}
.videoArtItem {
    padding-bottom: 20px;
    border-bottom: 1px solid #ddd;
    position: relative;
    margin-bottom: 14px;
    padding-left: 10px;
}
.videoArtItem a {
    font-size: 16px;
}
.videoArtItem::before {
    content: '|';
    color: #0b8686;
    position: absolute;
    left: -5px;
    font-weight: bold;
    font-size: 20px;
    top: -4px;
}
.tipsHover:hover .page_btn_active_link {
    color: #0b8686;
}
.tipsHover:hover .page_btn {
    background: #0b8686;
    color: #fff;
    border: 1px solid #0b8686;
}
</style>
